import { Box, Typography, IconButton, Link } from '@mui/material'
import { CheckCircle, Delete } from '@mui/icons-material'
import { GetDownloadUrl } from '../../../../../services/FileService'

interface Props {
  fileName: string | null | undefined
  fileKey: string | null | undefined
  onDelete: () => void
}

export function SurveyFileDisplay ({ fileName, fileKey, onDelete }: Props): JSX.Element | null {
  if (fileName == null || fileName === '') {
    return null
  }

  return (
    <Box sx={{
      mt: 2,
      p: 2,
      border: '1px solid #E1E1E2',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      bgcolor: '#F5F5F5'
    }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
        <CheckCircle color='success' sx={{ mr: 1, flexShrink: 0 }} />
        <Link
          href={fileKey != null ? GetDownloadUrl(fileKey) : '#'}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        >
          <Typography variant="body1" noWrap>{fileName}</Typography>
        </Link>
      </Box>
      <IconButton onClick={onDelete} aria-label="delete">
        <Delete />
      </IconButton>
    </Box>
  )
}
